export default "__VITE_ASSET__CkfMW29j__"